import { PromiseCard } from './types';

export const HERO = {
  title: 'Join Us',
  subtitle: 'Join our team and help shape the future of technology and innovation',
};

export const PROMISES: PromiseCard[] = [
  {
    id: 1,
    iconKey: 'lightbulb',
    title: 'Meaningful Work',
    description: 'Ship solutions in AI, ServiceNow, and custom platforms for mission-critical clients',
  },
  {
    id: 2,
    iconKey: 'bookOpen',
    title: 'Continuous Learning',
    description: 'Access to training, certifications, and conferences to grow your skills',
  },
  {
    id: 3,
    iconKey: 'balanceScale',
    title: 'Flexibility & Balance',
    description: 'Remote work options and flexible hours to fit your lifestyle',
  },
  {
    id: 4,
    iconKey: 'heart',
    title: 'Inclusive Community',
    description: 'Inclusive teams, regular feedback cycles, and visible career paths',
  },
];

export const GROW_WITH_US = {
  heading: 'Grow with BizSolutions.Tech',
  aboutBlock: {
    heading: 'Want to learn more about what we do?',
    body: 'Explore our mission, core values, and the industries we serve. See how BizSolutions.Tech partners with clients to drive innovation.',
    ctaLabel: 'Explore what we do',
    ctaHref: '/services',
  },
};

export const JOIN_US = {
  heading: 'Join Our Team',
  subtitle: "We're looking for talented professionals to join our growing company",
  openingsHeading: "We're Hiring For:",
  directContact: {
    heading: 'Having issues with the form?',
    body: 'Email us directly at:',
  },
  emptyJobsMessage: 'No job listings returned. If you expected data, confirm your API route returns an array.',
};

export const RESUME_FORM = {
  heading: 'Submit Your Resume',
  fallbackPositions: [
    'ServiceNow Architect',
    'ServiceNow Developer',
    'ServiceNow Integrator',
    'Training Curriculum Developer',
    'Online Learning Designer',
  ],
  submitLabel: 'Submit Application',
  submittingLabel: 'Submitting...',
  requiredFieldsAlert: 'Please fill in all required fields.',
};

export const SUCCESS_POPUP = {
  heading: 'Application Submitted!',
  body: 'Your application has been sent to info@bizsolutions.tech successfully.',
  followUp: "If you don't hear back within 48 hours, please email us directly at",
  closeLabel: 'Close',
};
